import React, { useState, useEffect, Fragment } from "react";
import { useParams } from "react-router-dom";
import { db } from "../../firebase/firebase-config";
import { doc, getDoc, collection, getDocs, updateDoc } from "firebase/firestore";
import { Dialog, Transition } from "@headlessui/react";
import AssessmentVisitHistory from "./AssessmentHistory";
import AddAssessmentVisitModal from "./AddAssessmentVisitModal";
import EditPainModal from "./EditPainModal";

export default function VisitDetail() {
    const { visitId } = useParams();
    const [visit, setVisit] = useState(null);
    const [patient, setPatient] = useState(null);
    const [assessments, setAssessments] = useState([]);
    const [interventionRecords, setInterventionRecords] = useState([]);
    const [editPainModal, setEditPainModal] = useState(false);
    const [painDetails, setPainDetails] = useState({ P: "", Q: "", R: "", S: "", T: "" });
    const [modal2, setModal2] = useState(false);
    const [patientId, setPatientId] = useState(null);

    useEffect(() => {
        const fetchVisitDetail = async () => {
            if (!visitId) return;

            const visitRef = doc(db, "visits", visitId);
            const visitSnap = await getDoc(visitRef);

            if (visitSnap.exists()) {
                const visitData = visitSnap.data();
                console.log("🔥 Data Visit:", visitData);

                setVisit(visitData);
                setPatientId(visitData.patientId || null);
                setPainDetails(visitData.painDetails || { P: "", Q: "", R: "", S: "", T: "" });
                setInterventionRecords(visitData.interventionRecords || []);

                // Ambil detail interventionRecords berdasarkan ID
                if (visitData.interventionRecords?.length > 0) {
                    fetchInterventionDetails(visitData.interventionRecords);
                }
            } else {
                console.log("🚨 Visit tidak ditemukan!");
            }
        };

        fetchVisitDetail();
    }, [visitId]);
    // Gunakan useEffect untuk melihat perubahan interventionRecords
    useEffect(() => {
        console.log("🔥 Updated InterventionRecords:", interventionRecords);
    }, [interventionRecords]);

    // Fetch detail intervention records
    const fetchInterventionDetails = async (interventionRecords) => {
        try {
            const records = [];
            for (const id of interventionRecords) {
                const docRef = doc(db, "intervention_records", id);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    records.push({ id, ...docSnap.data() });
                }
            }
            console.log("🔥 Updated InterventionRecords:", records);
            setAssessments(records);
        } catch (error) {
            console.error("Error fetching intervention records:", error);
        }
    };

    useEffect(() => {
        const fetchPatientDetail = async () => {
            if (!patientId) return;

            const patientRef = doc(db, "patients", patientId);
            const patientSnap = await getDoc(patientRef);

            if (patientSnap.exists()) {
                setPatient(patientSnap.data());
            }
        };

        fetchPatientDetail();
    }, [patientId]);

    const handleSavePainDetails = async () => {
        if (visitId) {
            const visitRef = doc(db, "visits", visitId);
            await updateDoc(visitRef, { painDetails });
            setVisit(prev => ({ ...prev, painDetails }));
            setEditPainModal(false);
        }
    };

    const handleNewAssessment = async (newAssessment) => {
        try {
            const docRef = await addDoc(collection(db, "interventionRecords"), newAssessment);
            setAssessments(prev => [...prev, { id: docRef.id, ...newAssessment }]);
            setModal2(false);
        } catch (error) {
            console.error("Error saving data: ", error);
        }
    };

    if (!visit) return <p>Loading...</p>;

    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold mb-4">Detail Kunjungan</h1>

            <table className="w-full border-collapse border border-gray-300 mb-6">
                <tbody>
                <tr><td className="border p-2 font-bold">Nama Pasien</td><td className="border p-2">{patient?.name || "Unknown"}</td></tr>
                <tr><td className="border p-2 font-bold">Email</td><td className="border p-2">{patient?.email || "Unknown"}</td></tr>
                <tr><td className="border p-2 font-bold">Tanggal Kunjungan</td><td className="border p-2">{visit.timestamp?.toDate ? new Date(visit.timestamp.toDate()).toLocaleString() : "Invalid Date"}</td></tr>
                </tbody>
            </table>

            <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-semibold">Informasi Nyeri</h3>
                <button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={() => setEditPainModal(true)}>Edit Nyeri</button>
            </div>

            <table className="w-full border border-gray-300">
                <tbody className="divide-y divide-gray-200">
                {["P", "Q", "R", "S", "T"].map((key) => (
                    <tr key={key} className="border ">
                        <td className="w-[80px] px-4 py-2 font-bold bg-gray-50 dark:bg-gray-800 border text-left">{key}</td>
                        <td className="px-4 py-2 border text-left font-medium  ">{painDetails[key] || ""}</td>
                    </tr>
                ))}
                </tbody>
            </table>

            <EditPainModal
                isOpen={editPainModal}
                onClose={() => setEditPainModal(false)}
                painDetails={painDetails}
                setPainDetails={setPainDetails}
                onSave={handleSavePainDetails}
            />
            <div className="flex justify-between items-center mb-4 mt-6">
                <h3 className="text-xl font-semibold">Pain Assessment</h3>
                <button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={() => setModal2(true)}>
                    Add Assessment
                </button>
            </div>

            <AssessmentVisitHistory assessments={assessments} />
            <AddAssessmentVisitModal isOpen={modal2} onClose={() => setModal2(false)} onSubmit={handleNewAssessment} patientId={patientId} visitId={visitId} />
        </div>
    );
}
